module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("d7kRr"))).then(() => parcelRequire('iDabs'));